module.exports = __webpack_public_path__ + "static/media/mc-feliz.e38be3f4.png";